import { render, staticRenderFns } from "./team_portfolio.vue?vue&type=template&id=30c84022&scoped=true&"
import script from "./team_portfolio.vue?vue&type=script&lang=js&"
export * from "./team_portfolio.vue?vue&type=script&lang=js&"
import style0 from "./team_portfolio.vue?vue&type=style&index=0&id=30c84022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c84022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30c84022')) {
      api.createRecord('30c84022', component.options)
    } else {
      api.reload('30c84022', component.options)
    }
    module.hot.accept("./team_portfolio.vue?vue&type=template&id=30c84022&scoped=true&", function () {
      api.rerender('30c84022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/view-team/team_portfolio.vue"
export default component.exports